import { useEffect, useState } from 'react';
import { useAppDispatch } from '../store';
import { getFirebaseAuth, registerLogout } from '../plugins/firebase';
import { getSession } from '../repositories/auth_repository';
import { loginAction, logoutAction } from '../store/slices/authSlice';
import type { User } from '../views/Home/constants';

interface AuthSyncResult {
  isReady: boolean;
}

interface SessionInfo {
  error?: string;
  rutas?: unknown[];
  idioma?: string;
  rol?: User['rol'];
  claims?: User['claims'];
}

export function useAuthSync(): AuthSyncResult {
  const [isReady, setIsReady] = useState(false);
  const dispatch = useAppDispatch();

  useEffect(() => {
    const auth = getFirebaseAuth();
    const unsubscribe = auth.onAuthStateChanged((user) => {
      void (async () => {
        try {
          if (user) {
            const token = await user.getIdToken();
            const session = (await getSession(token)) as SessionInfo | null;

            if (session && !session.error) {
              if (!session.rutas || session.rutas.length === 0) {
                await auth.signOut();
                registerLogout();
                dispatch(logoutAction());
                return;
              }

              const newLocale = session.idioma === 'es_ES' ? 'es' : 'de';
              localStorage.setItem('locale', newLocale);

              window.localStorage.setItem(
                'user',
                JSON.stringify({ email: user.email, rol: session.rol, claims: session.claims }),
              );

              dispatch(loginAction(user));
            } else {
              await auth.signOut();
              registerLogout();
              dispatch(logoutAction());
            }
          } else {
            localStorage.removeItem('user');
            dispatch(logoutAction());
          }
        } finally {
          // Marca como listo después del primer chequeo, independientemente del resultado
          setIsReady(true);
        }
      })();
    });

    return unsubscribe;
  }, [dispatch]);

  return { isReady };
}
